export default __webpack_public_path__ + "static/media/39.32d79a28.jpg";